/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import NavBar from "../components/global/NavBar";
import JSONPretty from 'react-json-pretty';
import {
  Grid,
  Paper,
  Tabs,
  Tab,
  CircularProgress,
  Typography
} from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Redirect } from "react-router-dom";
import ConfigurationPanel from "../components/classifiers/ConfigurationPanel";
import AlternativesSelect from "../components/classifiers/AlternativesSelect";
import {
  getTree,
  getRules,
  getMatrix,
  getGlobalExplanation,
  getLocalExplanation,
  getFuzzyLocalExplanation,
  getClassifications,
  getLogText,
  getJsonTree,
  getJsonRules,
  downloadLog,
  downloadJsonTree,
  downloadJsonRules,
  getClassificationsFuzzy,
  getDataset,
  getConfig,
  getTest,
  getSvgFingramLegend,
  getSvgFingramComplete,
  getSvgFingramPathfinder,
  getSvgFingramInconsistenciesPathfinder,
  buildSvgFingramInstance,
  getLogFingrams,
  getClassificationsHtRules,
  downloadLogFingrams,
  getSvgFingramTestComplete,
  getSvgFingramTestLegend,
  getSvgFingramTestPathfinder,
  getSvgFingramTestInconsistenciesPathfinder,
  buildSvgFingramInstanceTest,
  getClassificationsTreeFuzzy,
  getLogFingramsTest,
  getLogIEE,
  downloadLogIEE,
  getLogJFML,
  downloadLogJFML,
  getLogJFMLFURIA,
  downloadLogJFMLFURIA,
  buildFingrams, buildIEEE, buildFingramsTest
} from "../components/global/API";
import MenuItem from '@material-ui/core/MenuItem';
import ExplanationPanel from "../components/classifiers/ExplanationPanel";
import Tree from "../components/classifiers/Tree";
import Instances from "../components/classifiers/Instances";
import Rules from "../components/classifiers/Rules";
import Button from "@material-ui/core/Button";
import ResponsiveMatrix from "../components/classifiers/ResponsiveMatrix";
import Popover from "@material-ui/core/Popover";
import GetAppIcon from '@material-ui/icons/GetApp';
import IconButton from "@material-ui/core/IconButton";
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";
import galicia from "../components/images/galicia.png";
import usc from "../components/images/usc.png";
import campusVida from "../components/images/campusvida.png";
import ue from "../components/images/ue.png";
import xunta from "../components/images/xunta.png";
import xacobeo from "../components/images/xacobeo-color-original.jpg";
import citius_horizontal from "../components/images/citius_horizontal.png";

const styles = theme => ({
  paperRight: {
    padding: 10,
    margin: 5,
    height: "100%",
    minHeight: "500px",
    display: "flex",
    flexDirection: "column",
    marginBottom:50,
  },
  upper: {
    marginTop: 20,
    textTransform: "uppercase",
    color: "#283593"
  },
  root: {
    marginBottom:100,
    paddingTop: 64,
    paddingLeft: 20,
    paddingRight: 20,
    height: "100%"
  },
  progress: {
    margin: "auto",
    marginTop: 80,
    marginBottom: 30
  },
  loader: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    justifyItems: "center"
  },
  plainLogBox:{
    margin:"5px",
    width:"50%",
    padding:"5px",
    backgroundColor: "#fafafa",
    border: "2px solid #ccc",
    display: "inline-block",
    textAlign:"left",
    overflow:"scroll",
    [theme.breakpoints.down("lg")]: {
      width:"90%"
    },
  },
  plainLogBoxContenedor:{
    textAlign: "center",
    overflow:"scroll",
  },
  buttonDownload:{
    position:"relative",
    top:"0",
    right:"0"
  },
  footer:{
    boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
    display:"inline-table",
    justifyContent:"space-evenly",
    position:"fixed",
    bottom:0,
    height:100,
    left:0,
    width:"100%",
    backgroundColor:"white",
  },
  centerFotter:{
    display:"flex",
    justifyContent:"space-evenly",
  },
  leftLogos: {
    height: 36,
    marginTop: 20,
    marginBottom: 20
  },
  rightLogos: {
    height: 60,
    marginTop: 20,
    marginBottom: 20
  },
});

class ClassifierPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      algorithm: this.props.algorithm,
      panel: 0,
      loading: true,
      isDefault:
        this.props.dataset === "beer" ||
        this.props.dataset === "flavia" ||
        this.props.dataset === "iris" ||
        this.props.dataset === "glass" ||
        this.props.dataset === "wine" ||
        this.props.dataset === "vehicle"||
          this.props.dataset === "ACB" ||
          this.props.dataset === "PIMA" ||
          this.props.dataset === "OULAD" ||
          this.props.dataset === "bank" ,
      showInstances: false,
      selectedInstance:"train",
      anchorEl:null,
      fingramsType:"Complete",
      anchorElLog:null,
      fingramsTypeLog :"train",
      matrixType:"CVMatrix",
      JFMLType:"logIEEE",
      svgInstanceFlag:false,
      svgInstance:null,
      svgInstanceFlagTest:false,
      svgInstanceTest:null,
      comprobation :0,
      textSize:15,
    };
    this.changeAlternative = this.changeAlternative.bind(this);
    this.getDataset = this.getDataset.bind(this);
    this.getConfig = this.getConfig.bind(this);
    this.getTest = this.getTest.bind(this);
    this.updateTree = this.updateTree.bind(this);
    this.changeInstanceFingrams = this.changeInstanceFingrams.bind(this);
    this.updateRules = this.updateRules.bind(this);
    this.getTree = this.getTree.bind(this);
    this.getMatrix = this.getMatrix.bind(this);
    this.changeAlgorithm = this.changeAlgorithm.bind(this);
    this.getGlobalExplanation = this.getGlobalExplanation.bind(this);
    this.getLogText=this.getLogText.bind(this);
    this.downloadLog=this.downloadLog.bind(this);
    this.getJsonTree=this.getJsonTree.bind(this);
    this.downloadJsonTree=this.downloadJsonTree.bind(this);
    this.getJsonRules=this.getJsonRules.bind(this);
    this.getLogIEE = this.getLogIEE.bind(this);
    this.getLogJFML = this.getLogJFML.bind(this);
    this.getLogJFMLFURIA = this.getLogJFMLFURIA.bind(this);
    this.downloadLogIEE = this.downloadLogIEE.bind(this);
    this.downloadLogJFML = this.downloadLogJFML.bind(this);
    this.downloadLogJFMLFURIA = this.downloadLogJFMLFURIA.bind(this);
    this.getLogFingrams = this.getLogFingrams.bind(this);
    this.getLogFingramsTest = this.getLogFingramsTest.bind(this);
    this.downloadJsonRules=this.downloadJsonRules.bind(this);
    this.updateExplanations = this.updateExplanations.bind(this);
    this.updateMatrixExplanation = this.updateMatrixExplanation.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.getRules = this.getRules.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.changeTabTest = this.changeTabTest.bind(this);
    this.volverInicio = this.volverInicio.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClickLog = this.handleClickLog.bind(this);
    this.handleClickMatrix = this.handleClickMatrix.bind(this);
    this.handleClickJFML = this.handleClickJFML.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
    this.handleCloseMenuJFML = this.handleCloseMenuJFML.bind(this);
    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
    this.handleMenuItemClickMatrix = this.handleMenuItemClickMatrix.bind(this);
    this.handleMenuItemClickJFML = this.handleMenuItemClickJFML.bind(this);
    this.handleCloseMenuLog = this.handleCloseMenuLog.bind(this);
    this.handleCloseMenuMatrix = this.handleCloseMenuMatrix.bind(this);
    this.handleMenuItemClickLog = this.handleMenuItemClickLog.bind(this);
    this.downloadSvgComplete = this.downloadSvgComplete.bind(this);
    this.downloadSvgPathfinder = this.downloadSvgPathfinder.bind(this);
    this.downloadSvgInconsistencesPathfinder = this.downloadSvgInconsistencesPathfinder.bind(this);
    this.downloadLogFingrams = this.downloadLogFingrams.bind(this);
    this.changeComprobation = this.changeComprobation.bind(this);
    this.getSvgFingramTest = this.getSvgFingramTest.bind(this);
    this.downloadSvgCompleteTest = this.downloadSvgCompleteTest.bind(this);
    this.downloadSvgInconsistencesPathfinderTest = this.downloadSvgInconsistencesPathfinderTest.bind(this);
    this.downloadSvgPathfinderTest = this.downloadSvgPathfinderTest.bind(this);
    this.changeTextSize = this.changeTextSize.bind(this);
    this.rebuildFingrams = this.rebuildFingrams.bind(this);
    this.rebuildFingramsTest = this.rebuildFingramsTest.bind(this);
    this.rebuilLogIEEE = this.rebuilLogIEEE.bind(this);


  }

  async componentDidMount() {
    if (this.state.algorithm !== "FURIA" && this.state.algorithm !== "RandomForest" && this.state.algorithm !== "FuzzyHoeffdingDecisionTree" && this.state.matrixTest) {
      Promise.all([
          this.getConfig(),
          this.getDataset(),
        this.getTree(),
        this.getMatrix("cv"),
        this.getMatrix("train"),
        this.getMatrix("test"),
        this.getGlobalExplanation(),
        this.getLogText(),
        this.getJsonTree(),
        this.getLogIEE(),
        this.getLogJFML(),
      ]).then(() => {
        this.setState({
          loading: false
        });
      });
    } else if (this.state.algorithm !== "FURIA" && this.state.algorithm !== "RandomForest" && this.state.algorithm !== "FuzzyHoeffdingDecisionTree") {
      Promise.all([
        this.getConfig(),
        this.getDataset(),
        this.getTree(),
        this.getMatrix("cv"),
        this.getMatrix("train"),
        this.getGlobalExplanation(),
        this.getLogText(),
        this.getJsonTree(),
        this.getLogIEE(),
        this.getLogJFML(),
      ]).then(() => {
        this.setState({
          loading: false
        });
      });
    } else if (this.state.matrixTest && this.state.algorithm === "FURIA") {
      Promise.all([
        this.getConfig(),
        this.getDataset(),
        this.getRules(),
        this.getMatrix("cv"),
        this.getMatrix("train"),
        this.getMatrix("test"),
        this.getGlobalExplanation(),
        this.getLogText(),
        this.getJsonRules(),
        this.getLogIEE(),
        this.getLogJFML(),
        this.getLogJFMLFURIA(),
      ]).then(()=>[
        this.getLogFingrams(),
        this.getLogFingramsTest(),
        this.getSvgFingram(),
        this.getSvgFingramTest()
      ]).then(() => {
        this.setState({
          loading: false
        });
      });
    } else if(this.state.algorithm === "FURIA"){
      Promise.all([
        this.getConfig(),
        this.getDataset(),
        this.getRules(),
        this.getSvgFingram(),
        this.getMatrix("cv"),
        this.getMatrix("train"),
        this.getGlobalExplanation(),
        this.getLogText(),
        this.getJsonRules(),
        this.getLogFingrams(),
        this.getLogIEE(),
        this.getLogJFML(),
        this.getLogJFMLFURIA(),
      ]).then(() => {
        this.setState({
          loading: false
        });
      });
    }else if(this.state.matrixTest && this.state.algorithm === "RandomForest"){
      Promise.all([
        this.getConfig(),
        this.getDataset(),
        this.getMatrix("cv"),
        this.getMatrix("train"),
        this.getMatrix("test"),
        this.getGlobalExplanation(),
        this.getLogText(),
      ]).then(() => {
        this.setState({
          loading: false
        });
      });
    }else if( this.state.algorithm === "RandomForest"){
      Promise.all([
        this.getConfig(),
        this.getDataset(),
        this.getMatrix("cv"),
        this.getMatrix("train"),
        this.getGlobalExplanation(),
        this.getLogText(),
      ]).then(() => {
        this.setState({
          loading: false
        });
      });
    } else if(this.state.matrixTest){
      console.log('Este es el caso de llamada')
      console.log(this.state)
      Promise.all([
        this.getConfig(),
        this.getDataset(),
        this.getTree(),
        this.getRules(),
        this.getMatrix("cv"),
        this.getMatrix("train"),
        this.getMatrix("test"),
        this.getGlobalExplanation(),
        this.getLogText(),
        this.getJsonTree(),
        this.getJsonRules(),
        this.getLogIEE(),
        this.getLogJFML(),
      ]).then(()=>[
        this.getLogFingrams(),
        this.getLogFingramsTest(),
        this.getSvgFingram(),
        this.getSvgFingramTest()
      ]).then(() => {
        this.setState({
          loading: false
        });
      });
    }else{
      console.log(this.state)
      console.log('Este este otro')
      Promise.all([
        this.getConfig(),
        this.getDataset(),
        this.getTree(),
        this.getRules(),
        this.getMatrix("cv"),
        this.getMatrix("train"),
        this.getGlobalExplanation(),
        this.getLogText(),
        this.getJsonTree(),
        this.getJsonRules(),
        this.getLogIEE(),
        this.getLogJFML(),
      ]).then(() => [
        this.getLogFingrams(),
        this.getSvgFingram()
      ]).then(()=>{
        this.setState({
          loading: false
        });
      });
    }
  }
  changeComprobation(){
    this.setState({
      comprobation:1,
    })
  }
  componentDidUpdate(prevProps,prevState) {
    if (prevProps.language.id !== this.props.language.id) {
      this.setState({ loading: true });
      if (this.state.algorithm !== "FURIA" && this.state.algorithm !== "FuzzyHoeffdingDecisionTree" && this.state.algorithm !== "RandomForest") {
        Promise.all([this.getTree(), this.updateExplanations(),this.getJsonTree()]).then(() => {
          this.setState({
            loading: false
          });
        });
      } else if(this.state.algorithm !== "FuzzyHoeffdingDecisionTree" && this.state.algorithm !== "RandomForest"){
        Promise.all([this.getRules(),this.rebuildFingrams(),this.rebuildFingramsTest(), this.updateExplanations()]).then(() => {
          this.setState({
            loading: false
          });
        });
      }else if(this.state.algorithm === "RandomForest"){
        Promise.all([this.updateExplanations()]).then(() => {
          this.setState({
            loading: false
          });
        });
      }else{
        Promise.all([this.getRules(), this.getTree(),this.rebuildFingrams(),this.rebuildFingramsTest(),this.updateExplanations()]).then(() => {
          this.setState({
            loading: false
          });
        });
      }
    }
  }
  async changeTab(item) {
    console.log(item)
      await this.setState({
        panel:0,
        showInstances:false,
        instance:this.state.allInstances[item-1],
        selectedInstance:"train",
        selected:"train"
      })
    console.log('Hola tab')
  this.classify();
  }

  async changeTabTest(item) {
    await this.setState({
      panel:0,
      showInstances:false,
      instance:this.state.instancesTest[item-1],
      selectedInstance:"test",
      selected:"test"
    })
    console.log('Hola tab')
    this.classify();
  }

  async classify() {
    var instance;
    var showError = false;
    if (this.state.userInstance) {
      instance = this.state.userInstance;
    } else {
      instance = this.state.instance;
    }
    var values = { values: {} };
    for (var i = 0; i < this.state.config.attributes.length; i++) {
      values.values[instance.attributes[i + 1].id] =
          instance.attributes[i + 1].value;
    }
    if (!this.state.userInstance) {
      values["solution"] = instance.solution;
    }
    console.log(this.state.algorithm)
    if (!showError && this.state.algorithm !== "FURIA"  && this.state.algorithm !== "FuzzyHoeffdingDecisionTree") {
      var response = await getClassifications(
          this.props.dataset,
          this.state.algorithm,
          this.props.language.id,
          values,
          5,
          this.props.token
      );

      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
              "error",
              this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.setState({
          classifications: response.data,
          left: false
        });
        this.updateTree(response.data, values, this.state.percentage);
      }
    } else if (!showError  && this.state.algorithm === "FURIA") {
      response = await getClassificationsFuzzy(
          this.props.dataset,
          this.state.algorithm,
          this.props.language.id,
          values,
          this.state.percentage,
          this.props.token,
      );

      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
              "error",
              this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.setState({
          comprobation:1,
          classifications: response.data,
          left: false
        });
        this.updateRules(response.data, values, this.state.percentage);

      }
    } else if(!showError){
      response = await getClassificationsHtRules(
          this.props.dataset,
          this.state.algorithm,
          this.props.language.id,
          values,
          this.state.percentage,
          this.props.token
      );

      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
              "error",
              this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.setState({
          classifications: response.data,
          left: false
        });
        this.updateRules(response.data, values, this.state.percentage);
        console.log('Hola clasifico arbol')
        response = await getClassificationsTreeFuzzy(
            this.props.dataset,
            this.state.algorithm,
            this.props.language.id,
            values,
            this.state.percentage,
            this.props.token
        );

        if (response.error) {
          if (response.status === 401) {
            this.props.handleGlobalMessage(
                "error",
                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
            );
            this.props.closeSession();
            this.setState({
              redirect: true
            });
          } else {
            this.setState({
              error: true,
              message: response.data
            });
          }
        } else {
          this.setState({
            classifications: response.data,
            left: false
          });
        }
        this.changeComprobation();
        this.updateTree(response.data, values, this.state.percentage);
        if(this.state.selected ==="train") {
          response = await buildSvgFingramInstance(
              this.props.dataset,
              this.state.algorithm,
              this.props.token,
              this.state.instanceIndex
          );
          if (response.error) {
            if (response.status === 401) {
              this.props.handleGlobalMessage(
                  "error",
                  this.props.language.labels[this.props.language.id].errorMessageUnauthorized
              );
              this.props.closeSession();
              this.setState({
                loading: false,
                redirect: true
              });
            } else {
              this.setState({
                loading: false,
                error: true,
                message: response.data
              });
            }
          } else {
            this.setState({
              loading: false,
              ready: true,
            });
            this.changeInstanceFingrams(response.data,"train");
          }
        }else{
          response = await buildSvgFingramInstanceTest(
              this.props.dataset,
              this.state.algorithm,
              this.props.token,
              this.state.instanceIndex
          );
          if (response.error) {
            if (response.status === 401) {
              this.props.handleGlobalMessage(
                  "error",
                  this.props.language.labels[this.props.language.id].errorMessageUnauthorized
              );
              this.props.closeSession();
              this.setState({
                loading: false,
                redirect: true
              });
            } else {
              this.setState({
                loading: false,
                error: true,
                message: response.data
              });
            }
          } else {
            this.setState({
              loading: false,
              ready: true,
            });
            this.changeInstanceFingrams(response.data,"test");
          }
        }
      }

    }else {
      this.setState({
        error: true,
        message: "Wrong instance format, please check fields"
      });
    }
  }
  async getConfig() {
    var response = await getConfig(
        this.props.dataset,
        this.props.language.id,
        this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      this.setState(
          {
            config: response.data,
          },
          async () => {
            this.getTest();
          }
      );
    }
  }

  async getDataset() {
    var response = await getDataset(this.props.dataset, this.props.token);

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      }
      this.setState({
        error: true,
        message: response.data
      });
    } else {
      const labelsInstances = response.data.lines.map((instance, index) => ({
        value: index,
        label: "Instance " + (index + 1)
      }));
      console.log(response);
      this.setState({
        allInstances: response.data.lines,
        labelsInstances,
        selectedInstance: labelsInstances[0],
        instanceIndex: 0,
        instance: {
          attributes: response.data.lines[0].attributes,
          solution: response.data.lines[0].solution
        }
      });
    }
  }
  async getTest() {
    var response = await getTest(this.props.dataset, this.props.token);

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          selected: "train"
        });
      }
    } else {
      const labelsTestInstances = response.data.lines.map(
          (instance, index) => ({
            value: index,
            label: "Instance " + (index + 1)
          })
      );

      this.setState({
        instancesTest: response.data.lines,
        labelsTestInstances,
        selectedTestInstance: labelsTestInstances[0],
        instanceTestIndex: 0,
        instance: {
          attributes: response.data.lines[0].attributes,
          solution: response.data.lines[0].solution
        }
      });
      console.log('Aqui chegamos debería de leer test matrix')
      this.getMatrix("test");
      if(this.state.algorithm === "FuzzyHoeffdingDecisionTree" || this.state.algorithm === "FURIA") {
        this.getSvgFingramTest();
        this.getLogFingramsTest();
      }
    }
  }
  changeAlgorithm(algorithm) {
    this.props.changeAlgorithm(algorithm);
    this.props.changeCheckAlgorithm(algorithm);
    this.setState(
      {
        algorithm:algorithm,
        loading: true,
        panel:0
      },
      async () => {
        if (this.state.algorithm !== "FURIA" && this.state.algorithm !== "FuzzyHoeffdingDecisionTree" && this.state.algorithm !== "RandomForest" && this.state.matrixTest) {
          Promise.all([
            this.getTree(),
            this.getMatrix("cv"),
            this.getMatrix("train"),
            this.getMatrix("test"),
            this.getLogText(),
            this.getJsonTree(),
            this.getLogIEE(),
            this.getLogJFML(),
          ]).then(() => {
            this.updateExplanations();
            this.setState({
              loading: false
            });
          });
        } else if (this.state.algorithm !== "FURIA"  && this.state.algorithm !== "FuzzyHoeffdingDecisionTree" && this.state.algorithm !== "RandomForest") {
          Promise.all([
            this.getTree(),
            this.getMatrix("cv"),
            this.getMatrix("train"),
            this.getLogText(),
            this.getJsonTree(),
            this.getLogIEE(),
            this.getLogJFML(),
          ]).then(() => {
            this.updateExplanations();
            this.setState({
              loading: false
            });
          });
        } else if (this.state.matrixTest && this.state.algorithm === "FURIA") {
          Promise.all([
            this.getRules(),
            this.getMatrix("cv"),
            this.getMatrix("train"),
            this.getMatrix("test"),
            this.getLogText(),
            this.getJsonRules(),
            this.getLogIEE(),
            this.getLogJFML(),
            this.getLogJFMLFURIA(),
          ]).then(()=>[
            this.getLogFingrams(),
            this.getLogFingramsTest(),
            this.getSvgFingram(),
            this.getSvgFingramTest()
          ]).then(() => {
            this.updateExplanations();
            this.setState({
              loading: false
            });
          });
        } else  if(  this.state.algorithm === "FURIA") {
          Promise.all([
            this.getRules(),
            this.getSvgFingram(),
            this.getMatrix("cv"),
            this.getMatrix("train"),
            this.getLogText(),
            this.getJsonRules(),
            this.getLogFingrams(),
            this.getLogIEE(),
            this.getLogJFML(),
            this.getLogJFMLFURIA(),
          ]).then(() => {
            this.updateExplanations();
            this.setState({
              loading: false
            });
          });
        }else if (this.state.matrixTest && this.state.algorithm === "RandomForest") {
          Promise.all([
            this.getMatrix("cv"),
            this.getMatrix("train"),
            this.getMatrix("test"),
            this.getLogText(),
          ]).then(() => {
            this.updateExplanations();
            this.setState({
              loading: false
            });
          });
        } else  if(  this.state.algorithm === "RandomForest") {
          Promise.all([
            this.getMatrix("cv"),
            this.getMatrix("train"),
            this.getLogText(),
          ]).then(() => {
            this.updateExplanations();
            this.setState({
              loading: false
            });
          });
        }else if (this.state.matrixTest){
          Promise.all([
            this.getRules(),
            this.getTree(),
            this.getMatrix("cv"),
            this.getMatrix("train"),
            this.getMatrix("test"),
            this.getLogText(),
            this.getJsonTree(),
            this.getJsonRules(),
            this.getLogIEE(),
            this.getLogJFML(),
          ]).then(()=>[
            this.getLogFingrams(),
            this.getLogFingramsTest(),
            this.getSvgFingram(),
            this.getSvgFingramTest()
          ]).then(() => {
            this.updateExplanations();
            this.setState({
              loading: false
            });
          });
        }else{
          Promise.all([
            this.getRules(),
            this.getTree(),
            this.getSvgFingram(),
            this.getMatrix("cv"),
            this.getMatrix("train"),
            this.getLogText(),
            this.getJsonTree(),
            this.getJsonRules(),
            this.getLogFingrams(),
            this.getLogIEE(),
            this.getLogJFML(),
          ]).then(() => {
            this.updateExplanations();
            this.setState({
              loading: false
            });
          });
        }
      }
    );
  }

  updateMatrixExplanation(explanation) {
    var instances = [];
    var showInstances = false;

    if (explanation[1]) {
      showInstances = true;
      for (var i = 1; i < explanation.length; i++) {
        instances.push(explanation[i]);
      }
    }

    this.setState({
      matrixExplanation: explanation,
      instances,
      showInstances
    });
  }

  async getTree() {
    var response;

    if (this.state.values && this.state.algorithm !=="FuzzyHoeffdingDecisionTree") {
      response = await getClassifications(
        this.props.dataset,
        this.state.algorithm,
        this.props.language.id,
        this.state.values,
        this.state.tolerance,
        this.props.token
      );

      var alternatives = [];
      var solutions = [];

      if (response.error) {
        if (response.status === 401) {
          localStorage.clear();
          this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.setState({
            redirect: true
          });
        } else if (response.status === 404) {
          this.props.classifierDontExist(this.state.algorithm);
          this.setState({
            redirectForm: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        response.data.map(classification => {
          alternatives.push(classification.tree);
          solutions.push(classification.state);
          return true;
        });

        this.setState({
          alternativeIndex: 0,
          alternatives,
          classifications: response.data,
          solutions
        });
      }
    } else {
      response = await getTree(
        this.props.dataset,
        this.state.algorithm,
        this.props.language.id,
        this.props.token
      );

      if (response.error) {
        if (response.status === 401) {
          localStorage.clear();
          this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.setState({
            redirect: true
          });
        } else if (response.status === 404) {
          this.props.classifierDontExist(this.state.algorithm);
          this.setState({
            redirectForm: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.setState({
          alternativeIndex: 0,
          alternatives: [response.data],
          solutions: [response.data.state]
        });
      }
    }
  }

  async getRules() {
    var response;

    if (this.state.values && this.state.algorithm === "FURIA") {
      response = await getClassificationsFuzzy(
        this.props.dataset,
        this.state.algorithm,
        this.props.language.id,
        this.state.values,
        this.state.tolerance,
        this.props.token,
      );
      if (response.error) {
        if (response.status === 401) {
          localStorage.clear();
          this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.setState({
            redirect: true
          });
        } else if (response.status === 404) {
          this.props.classifierDontExist(this.state.algorithm);
          this.setState({
            redirectForm: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.setState({
          comprobation:1,
          rules: response.data
        });
      }
    }else if(this.state.values){
      response = await getClassificationsHtRules(
          this.props.dataset,
          this.state.algorithm,
          this.props.language.id,
          this.state.values,
          this.state.percentage,
          this.props.token
      );

      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
              "error",
              this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.setState({
          comprobation :1,
          classifications: response.data,
          left: false
        });
        this.updateRules(response.data, this.state.values, this.state.percentage);
        if(this.state.selectedInstance === "train") {
          response = await buildSvgFingramInstance(
              this.props.dataset,
              this.state.algorithm,
              this.props.token,
              this.state.instanceIndex
          );
          if (response.error) {
            if (response.status === 401) {
              this.props.handleGlobalMessage(
                  "error",
                  this.props.language.labels[this.props.language.id].errorMessageUnauthorized
              );
              this.props.closeSession();
              this.setState({
                loading: false,
                redirect: true
              });
            } else {
              this.setState({
                loading: false,
                error: true,
                message: response.data
              });
            }
          } else {
            this.setState({
              loading: false,
              ready: true,
            });
            this.changeInstanceFingrams(response.data,"train");
          }
        }else{
          response = await buildSvgFingramInstanceTest(
              this.props.dataset,
              this.state.algorithm,
              this.props.token,
              this.state.instanceIndex
          );
          if (response.error) {
            if (response.status === 401) {
              this.props.handleGlobalMessage(
                  "error",
                  this.props.language.labels[this.props.language.id].errorMessageUnauthorized
              );
              this.props.closeSession();
              this.setState({
                loading: false,
                redirect: true
              });
            } else {
              this.setState({
                loading: false,
                error: true,
                message: response.data
              });
            }
          } else {
            this.setState({
              loading: false,
              ready: true,
            });
            this.changeInstanceFingrams(response.data,"test");
          }
        }
      }
    } else {
      response = await getRules(
        this.props.dataset,
        this.state.algorithm,
        this.props.language.id,
        this.props.token
      );

      if (response.error) {
        if (response.status === 401) {
          localStorage.clear();
          this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.setState({
            redirect: true
          });
        } else if (response.status === 404) {
          this.props.classifierDontExist(this.state.algorithm);
          this.setState({
            redirectForm: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.setState({
          rules: response.data
        });
      }
    }
  }

  async getMatrix(type) {
    var response = await getMatrix(
      this.props.dataset,
      this.state.algorithm,
      this.props.token,
      type
    );
debugger
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
          "error",
          this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      var sum = [];
      response.data.data.map(row => {
        var rowSum = 0;
        row.map(column => {
          return (rowSum += column);
        });
        return sum.push(rowSum);
      });

      if (type === "cv") {
        this.setState({
          sum,
          matrixCV: response.data,
          percentageCV: response.data.precision.toFixed(2)
        });
      } else if (type === "train") {
        this.setState({
          sum,
          matrixTrain: response.data,
          percentageTrain: response.data.precision.toFixed(2)
        });
      } else {
        this.setState({
          sum,
          matrixTest: response.data,
          percentageTest: response.data.precision.toFixed(2)
        });
      }
    }
  }
  async getLogText(){
    var response= await getLogText(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    )
    console.log(response.data);
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.body
        });
      }
    } else {
      this.setState({
            plainText: response.data
          }
      )
    }
  }

  async getJsonTree(){
    var response= await getJsonTree(
        this.props.dataset,
        this.state.algorithm,
        this.props.token,
    )
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.body
        });
      }
    } else {
      this.setState({
            jsonTree:response.data// stringify with 4 spaces at each level
          }
      )
    }
  }
  async getLogIEE(){
    var response= await getLogIEE(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    )
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.body
        });
      }
    } else {
      this.setState({
            logIEE:response.data// stringify with 4 spaces at each level
          }
      )
    }
  }


  async getLogJFML(){
    var response= await getLogJFML(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    )
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.body
        });
      }
    } else {
      this.setState({
            logJFML:response.data// stringify with 4 spaces at each level
          }
      )
    }
  }
  async getLogJFMLFURIA(){
    var response= await getLogJFMLFURIA(
        this.props.dataset,
        this.props.token
    )
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.body
        });
      }
    } else {
      this.setState({
            logJFMLFURIA:response.data// stringify with 4 spaces at each level
          }
      )
    }
  }


  async getJsonRules(){
    var response= await getJsonRules(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    )
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.body
        });
      }
    } else {
      this.setState({
            jsonRules:response.data// stringify with 4 spaces at each level
          }
      )
    }
  }

  async getLogFingrams(){
    var response= await getLogFingrams(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    )
    console.log(response)
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.body
        });
      }
    } else {
      this.setState({
            logFingrams: response.data
          }
      )
    }
  }
  async getLogFingramsTest(){
    var response= await getLogFingramsTest(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    )
    console.log(response)
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.body
        });
      }
    } else {
      this.setState({
            logFingramsTest: response.data
          }
      )
    }
  }
  async getSvgFingram() {
    var response = await getSvgFingramComplete(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    )
    console.log(response.data);
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.body
        });
      }
    } else {
      this.setState({
            svgComplete: response.data
          },
          async () => {
            var responseLegend = await getSvgFingramLegend(
                this.props.dataset,
                this.state.algorithm,
                this.props.token
            );
            console.log(responseLegend.data);
            if (responseLegend.error) {
              if (responseLegend.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({redirect: true});
              } else {
                this.setState({
                  error: true,
                  message: responseLegend.body
                });
              }
            } else {
              this.setState({svgLegend: responseLegend.data},
                  async () => {
                    var responsePathfinder = await getSvgFingramPathfinder(
                        this.props.dataset,
                        this.state.algorithm,
                        this.props.token
                    );
                    console.log(responsePathfinder.data);
                    if (responsePathfinder.error) {
                      if (responsePathfinder.status === 401) {
                        this.props.handleGlobalMessage(
                            "error",
                            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                        );
                        this.props.closeSession();
                        this.setState({redirect: true});
                      } else {
                        this.setState({
                          error: true,
                          message: responsePathfinder.body
                        });
                      }
                    } else {
                      this.setState({svgPathfinder: responsePathfinder.data},
                          async () => {
                            var responseInconsistenciesPathfinder = await getSvgFingramInconsistenciesPathfinder(
                                this.props.dataset,
                                this.state.algorithm,
                                this.props.token
                            );
                            console.log(responseInconsistenciesPathfinder.data);
                            if (responseInconsistenciesPathfinder.error) {
                              if (responseInconsistenciesPathfinder.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({redirect: true});
                              } else {
                                this.setState({
                                  error: true,
                                  message: responseInconsistenciesPathfinder.body
                                });
                              }
                            } else {
                              this.setState({svgInconsistenciesPathfinder: responseInconsistenciesPathfinder.data})
                            }
                          });
                    }
                  });
            }
          });
    }
  }

  async getSvgFingramTest() {
    var response = await getSvgFingramTestComplete(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    )
    console.log(response.data);
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.body
        });
      }
    } else {
      this.setState({
            svgTestComplete: response.data
          },
          async () => {
            var responseLegend = await getSvgFingramTestLegend(
                this.props.dataset,
                this.state.algorithm,
                this.props.token
            );
            console.log(responseLegend.data);
            if (responseLegend.error) {
              if (responseLegend.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({redirect: true});
              } else {
                this.setState({
                  error: true,
                  message: responseLegend.body
                });
              }
            } else {
              this.setState({svgTestLegend: responseLegend.data},
                  async () => {
                    var responsePathfinder = await getSvgFingramTestPathfinder(
                        this.props.dataset,
                        this.state.algorithm,
                        this.props.token
                    );
                    console.log(responseLegend.data);
                    if (responsePathfinder.error) {
                      if (responsePathfinder.status === 401) {
                        this.props.handleGlobalMessage(
                            "error",
                            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                        );
                        this.props.closeSession();
                        this.setState({redirect: true});
                      } else {
                        this.setState({
                          error: true,
                          message: responsePathfinder.body
                        });
                      }
                    } else {
                      this.setState({svgTestPathfinder: responsePathfinder.data},
                          async () => {
                            var responseInconsistenciesPathfinder = await getSvgFingramTestInconsistenciesPathfinder(
                                this.props.dataset,
                                this.state.algorithm,
                                this.props.token
                            );
                            console.log(responseInconsistenciesPathfinder.data);
                            if (responseInconsistenciesPathfinder.error) {
                              if (responseInconsistenciesPathfinder.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({redirect: true});
                              } else {
                                this.setState({
                                  error: true,
                                  message: responseInconsistenciesPathfinder.body
                                });
                              }
                            } else {
                              this.setState({svgTestInconsistenciesPathfinder: responseInconsistenciesPathfinder.data})
                            }
                          });
                    }
                  });
            }
          });
    }
  }
  async downloadLog() {
    var response = await downloadLog(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      var url = window.URL.createObjectURL(response);
      var tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", this.props.dataset + ".txt");
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }
  }
  async rebuildFingrams() {
    var response = await buildFingrams(
        this.props.dataset,
        this.state.algorithm,
        this.props.token,
        this.props.language.id
    );
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          loading: false,
          redirect: true
        });
      } else {
        this.setState({
          loading: false,
          error: true,
          message: response.data
        });
      }
    } else {
      this.props.handleGlobalMessage(
          "success",
          "Dataset " + this.state.name + " succesfully modified"
      );
      await this.getSvgFingram();
      await this.getLogFingrams();
    }
  }
  async rebuildFingramsTest() {
    var response = await buildFingramsTest(
        this.props.dataset,
        this.state.algorithm,
        this.props.token,
        this.props.language.id
    );
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          loading: false,
          redirect: true
        });
      } else {
        this.setState({
          loading: false,
          error: true,
          message: response.data
        });
      }
    } else {
      this.props.handleGlobalMessage(
          "success",
          "Dataset " + this.state.name + " succesfully modified"
      );
      await this.getSvgFingramTest();
      await this.getLogFingramsTest();
    }
  }
  async rebuilLogIEEE() {
    var response = await buildIEEE(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    );
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          loading: false,
          redirect: true
        });
      } else {
        this.setState({
          loading: false,
          error: true,
          message: response.data
        });
      }
    } else {
      this.props.handleGlobalMessage(
          "success",
          "Dataset " + this.state.name + " succesfully created"
      );
      this.setState(
          {

          });
    }
  }
  async downloadLogFingrams() {
    var response = await downloadLogFingrams(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      var url = window.URL.createObjectURL(response);
      var tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", this.props.dataset + ".fs");
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }
  }

  async downloadJsonTree() {
    var response = await downloadJsonTree(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      var url = window.URL.createObjectURL(response);
      var tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", this.props.dataset + "Tree.json");
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }
  }

  async downloadJsonRules() {
    var response = await downloadJsonRules(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      var url = window.URL.createObjectURL(response);
      var tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", this.props.dataset + "Tree.json");
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }
  }
  async downloadLogIEE() {
    var response = await downloadLogIEE(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      var url = window.URL.createObjectURL(response);
      var tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", this.props.dataset + "logIEEE.rules.txt");
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }
  }
  async downloadLogJFML() {
    var response = await downloadLogJFML(
        this.props.dataset,
        this.state.algorithm,
        this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      var url = window.URL.createObjectURL(response);
      var tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", this.props.dataset + ".jfml.xml");
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }
  }
  async downloadLogJFMLFURIA() {
    var response = await downloadLogJFMLFURIA(
        this.props.dataset,
        this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      var url = window.URL.createObjectURL(response);
      var tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", this.props.dataset + ".rules.jfml.xml");
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }
  }

  async downloadSvgComplete() {
    var blob = new Blob([this.state.svgComplete], {type: 'image/svg+xml'});
    var url = window.URL.createObjectURL(blob);
    var tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download", this.props.dataset + "FingramsComplete.svg");
    document.body.appendChild(tempLink)
    tempLink.click();
    document.body.removeChild(tempLink);

    blob = new Blob([this.state.svgLegend], {type: 'image/svg+xml'});
    url = window.URL.createObjectURL(blob);
    tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download",this.props.dataset + "FingramsLegend.svg");
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }

  async downloadSvgPathfinder() {
    var blob = new Blob([this.state.svgPathfinder], {type: 'image/svg+xml'});
    var url = window.URL.createObjectURL(blob);
    var tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download", this.props.dataset + "FingramsPathFinder.svg");
    document.body.appendChild(tempLink)
    tempLink.click();
    document.body.removeChild(tempLink);

    blob = new Blob([this.state.svgLegend], {type: 'image/svg+xml'});
    url = window.URL.createObjectURL(blob);tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download",this.props.dataset + "FingramsLegend.svg");
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }
  async downloadSvgInconsistencesPathfinder (){
    var blob = new Blob([this.state.svgInconsistenciesPathfinder], {type: 'image/svg+xml'});
    var url = window.URL.createObjectURL(blob);
    var tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download", this.props.dataset + "FingramsInconsistencesPathfinder.svg");
    document.body.appendChild(tempLink)
    tempLink.click();
    document.body.removeChild(tempLink);

    blob = new Blob([this.state.svgLegend], {type: 'image/svg+xml'});
    url = window.URL.createObjectURL(blob);
    tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download",this.props.dataset + "FingramsLegend.svg");
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }
  async downloadSvgCompleteTest() {
    var blob = new Blob([this.state.svgTestComplete], {type: 'image/svg+xml'});
    var url = window.URL.createObjectURL(blob);
    var tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download", this.props.dataset + "FingramsComplete-test.svg");
    document.body.appendChild(tempLink)
    tempLink.click();
    document.body.removeChild(tempLink);

    blob = new Blob([this.state.svgTestLegend], {type: 'image/svg+xml'});
    url = window.URL.createObjectURL(blob);
    tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download",this.props.dataset + "FingramsLegend-test.svg");
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }

  async downloadSvgPathfinderTest() {
    var blob = new Blob([this.state.svgTestPathfinder], {type: 'image/svg+xml'});
    var url = window.URL.createObjectURL(blob);
    var tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download", this.props.dataset + "FingramsPathFinder-test.svg");
    document.body.appendChild(tempLink)
    tempLink.click();
    document.body.removeChild(tempLink);

    blob = new Blob([this.state.svgTestLegend], {type: 'image/svg+xml'});
    url = window.URL.createObjectURL(blob);tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download",this.props.dataset + "FingramsLegend-test.svg");
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }
  async downloadSvgInconsistencesPathfinderTest (){
    var blob = new Blob([this.state.svgTestInconsistenciesPathfinder], {type: 'image/svg+xml'});
    var url = window.URL.createObjectURL(blob);
    var tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download", this.props.dataset + "FingramsInconsistencesPathfinder-test.svg");
    document.body.appendChild(tempLink)
    tempLink.click();
    document.body.removeChild(tempLink);

    blob = new Blob([this.state.svgTestLegend], {type: 'image/svg+xml'});
    url = window.URL.createObjectURL(blob);
    tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download",this.props.dataset + "FingramsLegend-test.svg");
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }
  async getGlobalExplanation() {
    var response = await getGlobalExplanation(
      this.props.dataset,
      this.state.algorithm,
      this.props.language.id,
      this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
          "error",
          this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      this.setState({
        globalExplanation: response.data.clauses
      });
    }
  }

  updateTree(classifications, values, tolerance) {
    this.setState({ loading: true });

    var alternatives = [];
    var solutions = [];

    classifications.map(classification => {
      alternatives.push(classification.tree);
      solutions.push(classification.state);
      return true;
    });

    this.setState(
      {
        panel: 0,
        alternatives,
        solutions,
        alternativeIndex: 0,
        classifications,
        values,
        tolerance
      },
      async () => {
          Promise.all([this.updateExplanations()]).then(() => {
          this.setState({
            loading: false
          });
          });
      }
    );
  }
  changeInstanceFingrams(svg,type) {
    console.log('here')
    console.log(svg)
    console.log(type);
    if(svg!==undefined || svg!==null){
      if(type ==="train") {
        console.log(type);
        this.setState({
              svgInstanceFlag: true,
              svgInstance: svg,
            }
        )
      }else{
        this.setState({
              svgInstanceFlagTest: true,
              svgInstanceTest: svg,
            }
        )
      }
    }
  }
  updateRules(rules, values, tolerance) {
    this.setState({ loading: true });
    var message;
    var info;

    if (rules.uncovered) {
      info = true;
      if (rules.uncovAction === "stretch") {
        message = this.props.language.labels[this.props.language.id].stretch;
      } else if (rules.uncovAction === "frequent") {
        message = this.props.language.labels[this.props.language.id].frequent;
      } else {
        message = this.props.language.labels[this.props.language.id].abstain;
      }
    }
    this.setState(
      {
        panel: 0,
        info,
        message,
        rules,
        values,
        tolerance
      },
          async () => {
              Promise.all([this.updateExplanations()]).then(() => {
                this.setState({
                  loading: false
                });
              });
          }
    );
  }

  async updateExplanations() {
    var response;
    if (this.state.algorithm !== "FURIA"  && this.state.algorithm !== "FuzzyHoeffdingDecisionTree" && this.state.classifications) {
      response = await getLocalExplanation(
        this.props.dataset,
        this.state.algorithm,
        this.state.classifications,
        this.props.language.id,
        this.props.token
      );
      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.setState({
          localExplanation: response.data.clauses
        });
      }
    } else if (this.state.algorithm === "FURIA" && this.state.values) {
      response = await getFuzzyLocalExplanation(
        this.props.dataset,
        this.state.algorithm,
        this.state.rules,
        this.props.language.id,
        this.props.token
      );
      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.setState({
          localExplanation: response.data.clauses
        });
      }
    }else if(this.state.values && this.state.algorithm === "FuzzyHoeffdingDecisionTree"){
      response = await getFuzzyLocalExplanation(
          this.props.dataset,
          this.state.algorithm,
          this.state.rules,
          this.props.language.id,
          this.props.token
      );
      if (response.error) {
        if (response.status === 401) {
          this.props.handleGlobalMessage(
              "error",
              this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.props.closeSession();
          this.setState({
            redirect: true
          });
        } else {
          this.setState({
            error: true,
            message: response.data
          });
        }
      } else {
        this.setState({
          localExplanation: response.data.clauses
        });
      }
    }
    this.getGlobalExplanation();
  }

  closeDrawer() {
    this.setState({
      showInstances: false
    });
  }


  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({
      error: false,
      info: false,
      warning: false,
      success: false
    });
  };

  changeTextSize = (event, value) => {
    console.log(value);
    console.log(event)
    this.setState({
      textSize:value,
    })
  }
   handleChangeRightPanel = (event, value) => {
     if(this.state.algorithm === "FuzzyHoeffdingDecisionTree" ){
       if(value ===2 ){
         this.setState({
           matrixExplanation: true,
           panel:value,
         })
       }else {
         this.setState({
           matrixExplanation: undefined,
           panel: value,
         })
       }
     }else if(this.state.algorithm === "RandomForest" ){
       if(value ===0 ){
         this.setState({
           matrixExplanation: true,
           panel:value,
         })
       }else {
         this.setState({
           matrixExplanation: undefined,
           panel: value,
         })
       }
     }else{
        if(value ===1 ){
          this.setState({
            matrixExplanation: true,
            panel:value,
          })
        }else {
          this.setState({
            matrixExplanation: undefined,
            panel: value,
          })
        }
    }
  };
  volverInicio = (event) =>{
    this.setState({matrixExplanation:undefined});
  }
  changeAlternative(alternativeIndex) {
    this.setState({ alternativeIndex });
  }

  handleClick(event) {
    event.stopPropagation();
    this.setState({
      anchorEl: event.currentTarget
    });
  }

  handleCloseMenu() {
    this.setState({
      anchorEl: null
    });
  }

  handleMenuItemClick(menuItem,type) {
    this.handleClose();
    this.setState({
      panel: menuItem,
      fingramsType:type
    });
  }

  handleClickLog(event) {
    event.stopPropagation();
    this.setState({
      anchorElLog: event.currentTarget
    });
  }
  handleClickMatrix(event) {
    event.stopPropagation();
    this.setState({
      anchorElMatrix: event.currentTarget
    });
  }
  handleMenuItemClickMatrix(menuItem,type) {
    this.handleClose();
    this.setState({
      panel: menuItem,
      matrixType:type
    });
  }
  handleCloseMenuMatrix() {
    this.setState({
      anchorElMatrix: null
    });
  }
  handleClickJFML(event) {
    event.stopPropagation();
    this.setState({
      anchorElJFML: event.currentTarget
    });
  }
  handleMenuItemClickJFML(menuItem,type) {
    this.handleClose();
    this.setState({
      panel: menuItem,
      JFMLType:type
    });
  }
  handleCloseMenuJFML() {
    this.setState({
      anchorElJFML: null
    });
  }
  handleCloseMenuLog() {
    this.setState({
      anchorElLog: null
    });
  }

  handleMenuItemClickLog(menuItem,type) {
    this.handleClose();
    this.setState({
      panel: menuItem,
      fingramsTypeLog:type
    });
  }
  render() {
    const open = Boolean(this.state.anchorEl);
    const openLog = Boolean(this.state.anchorElLog);
    const openMatrix = Boolean(this.state.anchorElMatrix)
    const openJFML = Boolean(this.state.anchorElJFML)
    const { classes } = this.props;
    console.log(this.state.alternatives)
    var percentage;
    if(this.state.algorithm === "FuzzyHoeffdingDecisionTree") {
      if (this.state.panel === 0 || this.state.panel === 1|| this.state.panel === 2) {
        if(this.state.matrixType === "CVMatrix"){
          percentage = this.state.percentageCV;
        }else if(this.state.matrixType === "TrainMatrix"){
          percentage = this.state.percentageTrain;
        }else if(this.state.matrixType === "TestMatrix"){
          percentage = this.state.percentageTest;
        }else{
          percentage = this.state.percentageCV;
        }
      }else{
        percentage = this.state.percentageCV;
      }
    }else{
      if (this.state.panel === 0 || this.state.panel === 1) {
        if(this.state.matrixType === "CVMatrix"){
          percentage = this.state.percentageCV;
        }else if(this.state.matrixType === "TrainMatrix"){
          percentage = this.state.percentageTrain;
        }else if(this.state.matrixType === "TestMatrix"){
          percentage = this.state.percentageTest;
        }else{
          percentage = this.state.percentageCV;
        }
      }else{
        percentage = this.state.percentageCV;
      }
    }
    var value,valueLog,valueMatrix,valueIEE;
      if(this.state.algorithm !=="FuzzyHoeffdingDecisionTree" && this.state.algorithm !=="RandomForest") {
        valueIEE=4;
        valueMatrix = 1;
        value = 5;
        valueLog = 6;
      }else if(this.state.algorithm ==="FuzzyHoeffdingDecisionTree"){
        valueIEE=6
        valueMatrix = 2
        value = 7;
        valueLog = 8;
      }else{
        valueIEE=2
        valueMatrix=0;
      }



    return (
      <Fragment>
        <NavBar
          language={this.props.language}
          algorithm={this.state.algorithm}
          handleLanguageChange={this.props.handleLanguageChange}
          handleAlgorithmChange={this.changeAlgorithm}
          goToBuilder = {this.props.goToBuilder}
          classifierDontExist={this.props.classifierDontExist}
          dataset={this.props.dataset}
          goToComparation={this.props.goToComparation}
        />
        <Grid container className={classes.root}>
          <Grid item xs={12} md={12} lg={12}>
            <Paper className={classes.paperRight}>
              <ConfigurationPanel
                dataset={this.props.dataset}
                algorithm={this.state.algorithm}
                language={this.props.language}
                token={this.props.token}
                isDefault={this.state.isDefault}
                updateTree={this.updateTree}
                getTree={this.getTree}
                updateRules={this.updateRules}
                getRules={this.getRules}
                percentage={percentage}
                handleGlobalMessage={this.props.handleGlobalMessage}
                changeInstanceFingrams={this.changeInstanceFingrams}
                closeSession={this.props.closeSession}
                getMatrix={this.getMatrix}
                changeComprobation={this.changeComprobation}
                getSvgFingramTest = {this.getSvgFingramTest}
                getLogFingramsTest = {this.getLogFingramsTest}
              />
              {this.state.loading && (
                <div className={classes.loader}>
                  <CircularProgress className={classes.progress} size={100} />
                  <Typography variant="h3" align="center">
                    {this.props.language.labels[this.props.language.id].loading}
                  </Typography>
                </div>
              )}
              {!this.state.loading && (
                  <>
                <Tabs
                  value={this.state.panel}
                  onChange={this.handleChangeRightPanel}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons={"on"}
                >{this.state.algorithm !== "FURIA" && this.state.algorithm !=="RandomForest" &&
                  <Tab
                    className={classes.tabs}
                    style={{marginLeft:"auto"}}
                    label={this.props.language.labels[this.props.language.id]
                            .tree
                    }
                  />}
                  {(this.state.algorithm === "FURIA"
                  || this.state.algorithm === "FuzzyHoeffdingDecisionTree") &&
                  <Tab
                      className={classes.tabs}
                      style={this.state.algorithm === "FuzzyHoeffdingDecisionTree" ? {}: {marginLeft:"auto"}}
                      label={this.props.language.labels[this.props.language.id]
                                .rules
                      }
                  />
                  }
                  <Tab
                      classes={classes.tabs }
                      style={this.state.algorithm === "RandomForest" ? {marginLeft:"auto"}:{}}
                      label={
                        this.props.language.labels[this.props.language.id]
                            .matrixmenu
                      }
                      onClick={this.handleClickMatrix}
                  />

                  <Tab
                      className={classes.tabs}
                      style={this.state.algorithm === "RandomForest" ? {marginRight:"auto"}: {}}
                      label={
                        this.props.language.labels[this.props.language.id]
                            .plainText
                      }
                  />
                  {this.state.algorithm !== "FURIA" && this.state.algorithm !== "RandomForest" &&
                      <Tab
                      className={classes.tabs}
                      label={
                        this.props.language.labels[this.props.language.id]
                            .jsonTree
                      }
                  />}
                  {(this.state.algorithm === "FURIA" || this.state.algorithm === "FuzzyHoeffdingDecisionTree" ) &&
                  <Tab
                      className={classes.tabs}
                      label={
                        this.props.language.labels[this.props.language.id]
                            .jsonRules
                      }
                  />}
                  {(this.state.algorithm !== "RandomForest") &&
                  <Tab
                      className={classes.tabs}
                      style={this.state.algorithm !== "FURIA" && this.state.algorithm !== "FuzzyHoeffdingDecisionTree" && this.state.algorithm !=="RandomForest" ? {marginRight:"auto"}: {}}
                      label={
                        this.props.language.labels[this.props.language.id]
                            .logIEE
                      }
                      onClick={this.handleClickJFML}
                  />}
                  {(this.state.algorithm === "FURIA" || this.state.algorithm === "FuzzyHoeffdingDecisionTree") &&(
                  <Tab
                      classes={classes.tabs }
                      label={
                        this.props.language.labels[this.props.language.id]
                            .svgFingrams
                      }
                      onClick={this.handleClick}
                  />)}
                  {(this.state.algorithm === "FURIA" || this.state.algorithm === "FuzzyHoeffdingDecisionTree") && (
                      <Tab
                          classes={classes.tabs }
                          style={{marginRight:"auto"}}
                          label={
                            this.props.language.labels[this.props.language.id]
                                .logFingrams
                          }
                          onClick={this.handleClickLog}
                      />)}
                </Tabs>
                <Popover
                    open={openMatrix}
                    anchorEl={this.state.anchorElMatrix}
                    onClose={this.handleCloseMenuMatrix}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right"
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center"
                    }}>

                  <MenuItem onClick={() => this.handleMenuItemClickMatrix(valueMatrix,"CVMatrix")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .cvmatrix}</span>
                  </MenuItem>
                  <MenuItem onClick={() => this.handleMenuItemClickMatrix(valueMatrix,"TrainMatrix")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .trainmatrix}</span>
                  </MenuItem>
                  {this.state.matrixTest &&
                  <MenuItem onClick={() => this.handleMenuItemClickMatrix(valueMatrix, "TestMatrix")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .testmatrix}</span>
                  </MenuItem>
                  }
                </Popover>
                    <Popover
                        open={openJFML}
                        anchorEl={this.state.anchorElJFML}
                        onClose={this.handleCloseMenuJFML}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right"
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center"
                        }}>

                      <MenuItem onClick={() => this.handleMenuItemClickJFML(valueIEE,"logIEEE")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .logIEE}</span>
                      </MenuItem>
                      <MenuItem onClick={() => this.handleMenuItemClickJFML(valueIEE,"logJFML")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .logJFML}</span>
                      </MenuItem>
                      {this.props.algorithm === "FURIA" &&
                      <MenuItem onClick={() => this.handleMenuItemClickJFML(valueIEE,"logJFMLFURIA")}>
                        <span>{this.props.language.labels[this.props.language.id]
                            .logJFMLFURIA}</span>
                      </MenuItem>
                      }
                    </Popover>
                  <Popover
                    open={open}
                    anchorEl={this.state.anchorEl}
                    onClose={this.handleCloseMenu}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right"
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center"
                     }}>

                <MenuItem onClick={() => this.handleMenuItemClick(value,"Complete")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .complete}</span>
                    <IconButton aria-label="getApp"  style={{float:"right"}} onClick={this.downloadSvgComplete}><GetAppIcon></GetAppIcon></IconButton>
                </MenuItem>
                <MenuItem onClick={() => this.handleMenuItemClick(value,"Pathfinder")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .pathfinder}</span>
                  <IconButton aria-label="getApp"  style={{float:"right"}} onClick={this.downloadSvgPathfinder}><GetAppIcon></GetAppIcon></IconButton>
                </MenuItem>
                <MenuItem  onClick={() => this.handleMenuItemClick(value,"InconsistenciesPathfinder")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .inconsistenciesPathfinder}</span>
                  <IconButton  style={{float:"right"}} aria-label="getApp" onClick={this.downloadSvgInconsistencesPathfinder}><GetAppIcon></GetAppIcon></IconButton>

                  </MenuItem>
                    {this.state.svgInstanceFlag &&
                    <MenuItem onClick={() => this.handleMenuItemClick(value,"Instance")}>
                      <span>{this.props.language.labels[this.props.language.id]
                          .instanceFingramsClassification}</span>
                      <IconButton aria-label="getApp" style={{float:"right"}} onClick={this.downloadLog}><GetAppIcon></GetAppIcon></IconButton>
                    </MenuItem>
                    }
                    {this.state.matrixTest &&
                    <MenuItem onClick={() => this.handleMenuItemClick(value, "CompleteTest")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .completeTest}</span>
                      <IconButton aria-label="getApp" style={{float: "right"}}
                                  onClick={this.downloadSvgCompleteTest}><GetAppIcon></GetAppIcon></IconButton>
                    </MenuItem>
                    }
                    {this.state.matrixTest &&
                    <MenuItem onClick={() => this.handleMenuItemClick(value, "PathfinderTest")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .pathfinderTest}</span>
                      <IconButton aria-label="getApp" style={{float: "right"}} onClick={this.downloadSvgPathfinderTest}><GetAppIcon></GetAppIcon></IconButton>
                    </MenuItem>
                    }
                    {this.state.matrixTest &&
                    <MenuItem  onClick={() => this.handleMenuItemClick(value,"InconsistenciesPathfinderTest")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .inconsistenciesPathfinderTest}</span>
                      <IconButton  style={{float:"right"}} aria-label="getApp" onClick={this.downloadSvgInconsistencesPathfinderTest}><GetAppIcon></GetAppIcon></IconButton>

                    </MenuItem>
                        }
                    {this.state.svgInstanceFlagTest && this.state.matrixTest &&
                    <MenuItem onClick={() => this.handleMenuItemClick(value,"InstanceTest")}>
                      <span>{this.props.language.labels[this.props.language.id]
                          .instanceFingramsClassificationTest}</span>
                      <IconButton aria-label="getApp" style={{float:"right"}} onClick={this.downloadLog}><GetAppIcon></GetAppIcon></IconButton>
                    </MenuItem>
                    }
                </Popover>
                    {this.state.matrixTest &&
                    <Popover
                        open={openLog}
                        anchorEl={this.state.anchorElLog}
                        onClose={this.handleCloseMenuLog}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right"
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center"
                        }}>

                      <MenuItem onClick={() => this.handleMenuItemClickLog(valueLog, "train")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .logTrain}</span>
                      </MenuItem>
                      <MenuItem onClick={() => this.handleMenuItemClickLog(valueLog, "test")}>
                  <span>{this.props.language.labels[this.props.language.id]
                      .logTest}</span>
                      </MenuItem>
                    </Popover>
                    }
                </>
              )}
              {!this.state.loading &&
                this.state.algorithm !== "FURIA" &&
              this.state.algorithm !== "RandomForest" &&
                this.state.alternatives &&
                this.state.panel === 0 && (
                    <Fragment>
                    <AlternativesSelect
                      alternatives={this.state.alternatives}
                      changeAlternative={this.changeAlternative}
                    />
                                <Tree
                                    treeData={
                                      this.state.alternatives[this.state.alternativeIndex]
                                    }
                                    solution={
                                      this.state.solutions[this.state.alternativeIndex]
                                    }
                                    textSize={this.state.textSize}
                                    orientation={"horizontal"}
                                />
                    </Fragment>
                )}
              {!this.state.loading &&
                this.state.algorithm === "FURIA" &&
                this.state.rules &&
                this.state.panel === 0 && (
                  <Rules
                    rules={this.state.rules}
                    language={this.props.language}
                    comprobation={this.state.comprobation}
                  />
                )}
              {!this.state.loading &&
              this.state.algorithm === "FuzzyHoeffdingDecisionTree" &&
              this.state.rules &&
              this.state.panel === 1 && (
                  <Rules
                      rules={this.state.rules}
                      language={this.props.language}
                      comprobation={this.state.comprobation}

                  />
              )}
              {(
                  (!this.state.loading && this.state.panel === 1 && this.state.algorithm!=="FuzzyHoeffdingDecisionTree" && this.state.algorithm!=="RandomForest" && this.state.matrixType === "CVMatrix") ||
                  (!this.state.loading && this.state.algorithm==="FuzzyHoeffdingDecisionTree" && this.state.panel===2 && this.state.matrixType === "CVMatrix")||
                  (!this.state.loading && this.state.algorithm==="RandomForest" && this.state.panel===0  && this.state.matrixType === "CVMatrix")
              )
              && (
                  <ResponsiveMatrix
                      volverInicio={this.volverInicio}
                    dataset={this.props.dataset}
                    algorithm={this.state.algorithm}
                    token={this.props.token}
                    sum={this.state.sum}
                    matrix={this.state.matrixCV}
                    type="cv"
                    language={this.props.language}
                    updateMatrixExplanation={this.updateMatrixExplanation}
                    handleGlobalMessage={this.props.handleGlobalMessage}
                    closeSession={this.props.closeSession}
                  />
                )
              }
              {((!this.state.loading && this.state.panel === 1 && this.state.algorithm!=="FuzzyHoeffdingDecisionTree" && this.state.algorithm!=="RandomForest" && this.state.matrixType === "TrainMatrix") ||
              (!this.state.loading && this.state.algorithm==="FuzzyHoeffdingDecisionTree" && this.state.panel===2  && this.state.matrixType === "TrainMatrix")||
                  (!this.state.loading && this.state.algorithm==="RandomForest" && this.state.panel===0  && this.state.matrixType === "TrainMatrix")) && (
                          <ResponsiveMatrix
                              volverInicio={this.volverInicio}
                              dataset={this.props.dataset}
                              algorithm={this.state.algorithm}
                              token={this.props.token}
                              sum={this.state.sum}
                              matrix={this.state.matrixTrain}
                              type="train"
                              language={this.props.language}
                              handleGlobalMessage={this.props.handleGlobalMessage}
                              updateMatrixExplanation={this.updateMatrixExplanation}
                              closeSession={this.props.closeSession}
                          />

                )}
              {((!this.state.loading && this.state.matrixTest && this.state.panel === 1 && this.state.algorithm !== "FuzzyHoeffdingDecisionTree" && this.state.algorithm!=="RandomForest" && this.state.matrixType === "TestMatrix" )
                  || (!this.state.loading && this.state.matrixTest && this.state.algorithm==="FuzzyHoeffdingDecisionTree" && this.state.panel === 2 && this.state.matrixType === "TestMatrix")||
                  (!this.state.loading && this.state.algorithm==="RandomForest" && this.state.panel===0  && this.state.matrixType === "TestMatrix"))&& (
                  <ResponsiveMatrix
                      volverInicio={this.volverInicio}
                    dataset={this.props.dataset}
                    algorithm={this.state.algorithm}
                    token={this.props.token}
                    sum={this.state.sum}
                    matrix={this.state.matrixTest}
                    type="test"
                    language={this.props.language}
                    handleGlobalMessage={this.props.handleGlobalMessage}
                    updateMatrixExplanation={this.updateMatrixExplanation}
                    closeSession={this.props.closeSession}
                  />
                )}
              {((!this.state.loading  && this.state.panel === 2 && this.state.algorithm!=="FuzzyHoeffdingDecisionTree" && this.state.algorithm!=="RandomForest") ||
                  (!this.state.loading   && this.state.algorithm==="FuzzyHoeffdingDecisionTree" && this.state.panel === 3 )||
                  (!this.state.loading && this.state.algorithm==="RandomForest" && this.state.panel===1 ))&& (
                  <div className={classes.plainLogBoxContenedor}>
                    <div className={classes.buttonDownload}>
                      <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          onClick={this.downloadLog}
                      >
                        {this.props.language.labels[this.props.language.id].download}
                      </Button>
                    </div>
                  <div className={classes.plainLogBox}>
                  <pre>{this.state.plainText}</pre>
                  </div>
                  </div>
              )}
              {((!this.state.loading &&  this.state.panel === 3 && this.state.algorithm!=="FuzzyHoeffdingDecisionTree" && this.state.algorithm !== "FURIA") ||
                  (!this.state.loading  && this.state.panel === 4 && this.state.algorithm==="FuzzyHoeffdingDecisionTree" && this.state.algorithm !== "FURIA"))&& (
                  <div className={classes.plainLogBoxContenedor}>
                    <div className={classes.buttonDownload}>
                      <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          onClick={this.downloadJsonTree}
                      >
                        {this.props.language.labels[this.props.language.id].download}
                      </Button>
                    </div>
                    <div className={classes.plainLogBox}>
                      <JSONPretty id="json-pretty" data={this.state.jsonTree}></JSONPretty>
                    </div>
                  </div>
              )}
              {((!this.state.loading  && this.state.panel === 3 && this.state.algorithm!=="FuzzyHoeffdingDecisionTree" && this.state.algorithm === "FURIA") ||
                  (!this.state.loading && this.state.panel === 5 && this.state.algorithm==="FuzzyHoeffdingDecisionTree" ))&& (
                  <div className={classes.plainLogBoxContenedor}>
                    <div className={classes.buttonDownload}>
                      <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          onClick={this.downloadJsonRules}
                      >
                        {this.props.language.labels[this.props.language.id].download}
                      </Button>
                    </div>
                    <div className={classes.plainLogBox}>
                      <JSONPretty id="json-pretty" data={this.state.jsonRules}></JSONPretty>
                    </div>
                  </div>
              )}
              {((!this.state.loading &&  this.state.panel === 4 && this.state.algorithm!=="FuzzyHoeffdingDecisionTree" && this.state.algorithm !== "FURIA" && this.state.JFMLType === "logIEEE")
                  ||(!this.state.loading  && this.state.panel === 4 && this.state.algorithm!=="FuzzyHoeffdingDecisionTree" && this.state.algorithm === "FURIA" && this.state.JFMLType === "logIEEE") ||
                  (!this.state.loading && this.state.panel === 6 && this.state.algorithm==="FuzzyHoeffdingDecisionTree" && this.state.JFMLType === "logIEEE"))&& (
                  <div className={classes.plainLogBoxContenedor}>
                    <div className={classes.buttonDownload}>
                      <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          onClick={this.downloadLogIEE}
                      >
                        {this.props.language.labels[this.props.language.id].download}
                      </Button>
                      &nbsp;&nbsp;&nbsp;
                      {!this.state.isDefault &&
                      <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          onClick={this.rebuilLogIEEE}
                      >
                        {this.props.language.labels[this.props.language.id].rebuild}
                      </Button>
                      }
                    </div>
                    <div className={classes.plainLogBox}>
                      <JSONPretty id="json-pretty" data={this.state.logIEE}></JSONPretty>
                    </div>
                  </div>
              )}
              {((!this.state.loading &&  this.state.panel === 4 && this.state.algorithm!=="FuzzyHoeffdingDecisionTree" && this.state.algorithm !== "FURIA" && this.state.JFMLType === "logJFML")
                  ||(!this.state.loading  && this.state.panel === 4 && this.state.algorithm!=="FuzzyHoeffdingDecisionTree" && this.state.algorithm === "FURIA" && this.state.JFMLType === "logJFML") ||
                  (!this.state.loading && this.state.panel === 6 && this.state.algorithm==="FuzzyHoeffdingDecisionTree" && this.state.JFMLType === "logJFML" ))&& (
                  <div className={classes.plainLogBoxContenedor}>
                    <div className={classes.buttonDownload}>
                      <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          onClick={this.downloadLogJFML}
                      >
                        {this.props.language.labels[this.props.language.id].download}
                      </Button>
                      {!this.state.isDefault &&
                      <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          onClick={this.rebuilLogIEEE}
                      >
                        {this.props.language.labels[this.props.language.id].rebuild}
                      </Button>
                      }
                    </div>
                    <div className={classes.plainLogBox}>
                      <JSONPretty id="json-pretty" data={this.state.logJFML}></JSONPretty>
                    </div>
                  </div>
              )}
              {((!this.state.loading  && this.state.panel === 4 && this.state.algorithm!=="FuzzyHoeffdingDecisionTree" && this.state.algorithm === "FURIA" && this.state.JFMLType === "logJFMLFURIA"))&& (
                  <div className={classes.plainLogBoxContenedor}>
                    <div className={classes.buttonDownload}>
                      <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          onClick={this.downloadLogJFMLFURIA}
                      >
                        {this.props.language.labels[this.props.language.id].download}
                      </Button>
                    </div>
                    <div className={classes.plainLogBox}>
                      <JSONPretty id="json-pretty" data={this.state.logJFMLFURIA}></JSONPretty>
                    </div>
                  </div>
              )}
              {((!this.state.loading && this.state.algorithm === "FURIA" && this.state.panel === 5  && this.state.fingramsType === "Complete")  ||
                  (!this.state.loading && this.state.algorithm === "FuzzyHoeffdingDecisionTree" && this.state.panel===7  && this.state.fingramsType === "Complete"))
                && (

                      <div style={{marginBottom:"100px",textAlign:"center",fontFamily:"Roboto",marginLeft :"auto",marginRight :"auto"}} >
                        <Grid container spacing={4}>
                          <Grid item xs={12}>
                            <h1>{this.props.language.labels[this.props.language.id].complete}</h1>
                          </Grid>

                          <Grid item xs={12}  sm={12} md={9} xl={11} >
                            <TransformWrapper>
                              <TransformComponent>
                                <div dangerouslySetInnerHTML={{ __html: this.state.svgComplete }} />
                              </TransformComponent>
                            </TransformWrapper>
                          </Grid>
                          <Grid item xs={12}  sm={12} md={3} xl={1} >
                            <div dangerouslySetInnerHTML={{ __html: this.state.svgLegend }} />
                          </Grid>
                        </Grid>
                      </div>

              )}
              {((!this.state.loading && this.state.algorithm === "FURIA" && this.state.panel === 5  && this.state.fingramsType === "Pathfinder") ||
                  (!this.state.loading && this.state.algorithm === "FuzzyHoeffdingDecisionTree" && this.state.panel===7 && this.state.fingramsType === "Pathfinder"))
              && (

                      <div style={{marginBottom:"100px",textAlign:"center",fontFamily:"Roboto",marginLeft :"auto",marginRight :"auto"}} >
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <h1>{this.props.language.labels[this.props.language.id].pathfinder}</h1>
                          </Grid>
                              <Grid xs={12}  sm={12} md={9} xl={11}>
                                <TransformWrapper>
                                  <TransformComponent>
                                    <div dangerouslySetInnerHTML={{ __html: this.state.svgPathfinder }} />
                                  </TransformComponent>
                                </TransformWrapper>
                              </Grid>

                          <Grid item xs={12}  sm={12} md={3} xl={1} >
                            <div dangerouslySetInnerHTML={{ __html: this.state.svgLegend }} />
                          </Grid>
                        </Grid>
                      </div>

              )}
              {((!this.state.loading && this.state.algorithm === "FURIA" && this.state.panel === 5  && this.state.fingramsType === "InconsistenciesPathfinder" ) ||
                  (!this.state.loading && this.state.algorithm === "FuzzyHoeffdingDecisionTree" && this.state.panel===7 &&  this.state.fingramsType === "InconsistenciesPathfinder"))
              && (

                      <div style={{marginBottom:"100px",textAlign:"center",fontFamily:"Roboto",marginLeft :"auto",marginRight :"auto"}} >
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <h1>{this.props.language.labels[this.props.language.id].inconsistenciesPathfinder}</h1>
                          </Grid>
                          <Grid item xs={12}  sm={12} md={9} xl={11} >
                            <TransformWrapper>
                              <TransformComponent>
                                <div dangerouslySetInnerHTML={{ __html: this.state.svgInconsistenciesPathfinder }} />
                              </TransformComponent>
                            </TransformWrapper>
                          </Grid>
                          <Grid item xs={12}  sm={12} md={3} xl={1} >
                            <div dangerouslySetInnerHTML={{ __html: this.state.svgLegend }} />
                          </Grid>
                        </Grid>
                      </div>

              )}
              {((!this.state.loading && this.state.algorithm === "FURIA" && this.state.panel === 5 && this.state.fingramsType === "Instance" ) ||
                  (!this.state.loading && this.state.algorithm === "FuzzyHoeffdingDecisionTree" && this.state.panel===7  && this.state.fingramsType === "Instance")
                ) && (

                      <div style={{marginBottom:"100px",textAlign:"center",fontFamily:"Roboto",marginLeft :"auto",marginRight :"auto"}} >
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <h1>Instance classification</h1>
                          </Grid>
                          <Grid item xs={12}  sm={12} md={9} xl={11} >
                            <TransformWrapper>
                              <TransformComponent >
                                <div dangerouslySetInnerHTML={{ __html: this.state.svgInstance }} />
                              </TransformComponent>
                            </TransformWrapper>
                          </Grid>
                          <Grid item xs={12}  sm={12} md={3} xl={1} >
                            <div dangerouslySetInnerHTML={{ __html: this.state.svgLegend }} />
                          </Grid>
                        </Grid>
                      </div>

              )}
              {((!this.state.loading && this.state.algorithm === "FURIA" && this.state.panel === 5  && this.state.fingramsType === "CompleteTest")  ||
                  (!this.state.loading && this.state.algorithm === "FuzzyHoeffdingDecisionTree" && this.state.panel===7  && this.state.fingramsType === "CompleteTest"))
              && (

                  <div style={{marginBottom:"100px",textAlign:"center",fontFamily:"Roboto",marginLeft :"auto",marginRight :"auto"}} >
                    <Grid container spacing={4}>
                      <Grid item xs={12}>
                        <h1>{this.props.language.labels[this.props.language.id].completeTest}</h1>
                      </Grid>

                      <Grid item xs={12}  sm={12} md={9} xl={11} >
                        <TransformWrapper>
                          <TransformComponent>
                            <div dangerouslySetInnerHTML={{ __html: this.state.svgTestComplete }} />
                          </TransformComponent>
                        </TransformWrapper>
                      </Grid>
                      <Grid item xs={12}  sm={12} md={3} xl={1} >
                        <div dangerouslySetInnerHTML={{ __html: this.state.svgTestLegend }} />
                      </Grid>
                    </Grid>
                  </div>

              )}
              {((!this.state.loading && this.state.algorithm === "FURIA" && this.state.panel === 5 &&  this.state.fingramsType === "PathfinderTest") ||
                  (!this.state.loading && this.state.algorithm === "FuzzyHoeffdingDecisionTree" && this.state.panel===7   && this.state.fingramsType === "PathfinderTest"))
              && (

                  <div style={{marginBottom:"100px",textAlign:"center",fontFamily:"Roboto",marginLeft :"auto",marginRight :"auto"}} >
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <h1>{this.props.language.labels[this.props.language.id].pathfinderTest}</h1>
                      </Grid>
                      <Grid xs={12}  sm={12} md={9} xl={11}>
                        <TransformWrapper>
                          <TransformComponent>
                            <div dangerouslySetInnerHTML={{ __html: this.state.svgTestPathfinder }} />
                          </TransformComponent>
                        </TransformWrapper>
                      </Grid>

                      <Grid item xs={12}  sm={12} md={3} xl={1} >
                        <div dangerouslySetInnerHTML={{ __html: this.state.svgTestLegend }} />
                      </Grid>
                    </Grid>
                  </div>

              )}
              {((!this.state.loading && this.state.algorithm === "FURIA" && this.state.panel === 5  && this.state.fingramsType === "InconsistenciesPathfinderTest" ) ||
                  (!this.state.loading && this.state.algorithm === "FuzzyHoeffdingDecisionTree" && this.state.panel===7 && this.state.fingramsType === "InconsistenciesPathfinderTest"))
              && (

                  <div style={{marginBottom:"100px",textAlign:"center",fontFamily:"Roboto",marginLeft :"auto",marginRight :"auto"}} >
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <h1>{this.props.language.labels[this.props.language.id].inconsistenciesPathfinderTest}</h1>
                      </Grid>
                      <Grid item xs={12}  sm={12} md={9} xl={11} >
                        <TransformWrapper>
                          <TransformComponent>
                            <div dangerouslySetInnerHTML={{ __html: this.state.svgTestInconsistenciesPathfinder }} />
                          </TransformComponent>
                        </TransformWrapper>
                      </Grid>
                      <Grid item xs={12}  sm={12} md={3} xl={1} >
                        <div dangerouslySetInnerHTML={{ __html: this.state.svgTestLegend }} />
                      </Grid>
                    </Grid>
                  </div>

              )}
              {((!this.state.loading && this.state.algorithm === "FURIA" && this.state.panel === 5  && this.state.fingramsType === "InstanceTest" ) ||
                  (!this.state.loading && this.state.algorithm === "FuzzyHoeffdingDecisionTree" && this.state.panel===7  && this.state.fingramsType === "InstanceTest")
              ) && (

                  <div style={{marginBottom:"100px",textAlign:"center",fontFamily:"Roboto",marginLeft :"auto",marginRight :"auto"}} >
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <h1>Instance classification</h1>
                      </Grid>
                      <Grid item xs={12}  sm={12} md={9} xl={11} >
                        <TransformWrapper>
                          <TransformComponent >
                            <div dangerouslySetInnerHTML={{ __html: this.state.svgInstanceTest }} />
                          </TransformComponent>
                        </TransformWrapper>
                      </Grid>
                      <Grid item xs={12}  sm={12} md={3} xl={1} >
                        <div dangerouslySetInnerHTML={{ __html: this.state.svgTestLegend }} />
                      </Grid>
                    </Grid>
                  </div>

              )}
              {((!this.state.loading && this.state.algorithm === "FURIA"  && this.state.panel === 6 && this.state.fingramsTypeLog ==="train" ) ||
              (!this.state.loading && this.state.algorithm === "FuzzyHoeffdingDecisionTree" && this.state.panel===8 && this.state.fingramsTypeLog ==="train"))
              && (

                  <div style={{marginBottom:"100px",textAlign:"center",fontFamily:"Roboto"}} >
                    <div className={classes.plainLogBoxContenedor}>
                      <div className={classes.buttonDownload}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={this.downloadLogFingrams}
                        >
                          {this.props.language.labels[this.props.language.id].download}
                        </Button>
                        &nbsp;&nbsp;&nbsp;
                        {!this.state.isDefault &&
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={this.rebuildFingrams}
                        >
                          {this.props.language.labels[this.props.language.id].rebuild}
                        </Button>
                        }
                      </div>
                      <div className={classes.plainLogBox}>
                        <pre >{this.state.logFingrams}</pre>
                      </div>
                    </div>
                  </div>
              )}
              {((!this.state.loading && this.state.algorithm === "FURIA"  && this.state.panel === 6 && this.state.fingramsTypeLog ==="test" ) ||
                  (!this.state.loading && this.state.algorithm === "FuzzyHoeffdingDecisionTree" && this.state.panel===8  && this.state.fingramsTypeLog ==="test" ))
              && (

                  <div style={{marginBottom:"100px",textAlign:"center",fontFamily:"Roboto"}} >
                    <div className={classes.plainLogBoxContenedor}>
                      <div className={classes.buttonDownload}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={this.downloadLogFingrams}
                        >
                          {this.props.language.labels[this.props.language.id].download}
                        </Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={this.rebuildFingramsTest}
                        >
                          {this.props.language.labels[this.props.language.id].rebuild}
                        </Button>
                      </div>
                      <div className={classes.plainLogBox}>
                        <pre >{this.state.logFingramsTest}</pre>
                      </div>
                    </div>
                  </div>
              )}
              {!this.state.loading && (
                <ExplanationPanel
                  language={this.props.language}
                  globalExplanation={this.state.globalExplanation}
                  localExplanation={this.state.localExplanation}
                  matrixExplanation={this.state.matrixExplanation}
                />
              )}
            </Paper>
          </Grid>
        </Grid>
        <footer className={classes.footer}>
          <Grid container direction="row" alignItems="center" justify={"center"}>
            <Grid  className={classes.centerFotter} item xs={12} md={8} lg={8} >
              <img
                  src={galicia}
                  alt="logo turístico galicia"
                  className={classes.leftLogos}
              />
              <img
                  src={xacobeo}
                  alt="logo xacobeo 2021"
                  className={classes.leftLogos}
              />
              <img src={citius_horizontal} alt="logo citius" className={classes.leftLogos} />
              <img src={usc} alt="logo usc" className={classes.leftLogos} />
              <img
                  src={campusVida}
                  alt="logo campus vida"
                  className={classes.leftLogos}
              />
            </Grid>
            <Grid className={classes.centerFotter}  item xs={12} md={4} lg={4} >
              <img
                  src={ue}
                  alt="logo unión europea"
                  className={classes.rightLogos}
              />
              <img
                  src={xunta}
                  alt="logo xunta de galicia"
                  className={classes.rightLogos}
              />
            </Grid>
          </Grid>
          <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "center"}}>
            {this.props.language.labels[this.props.language.id].fondoEuropeo}
          </Typography>
        </footer>
        <Instances
          algorithm={this.state.algorithm}
          volverInicio={this.volverInicio}
          show={this.state.showInstances}
          instances={this.state.instances}
          changeTab={this.changeTab}
          changeTabTest={this.changeTabTest}
          closeDrawer={this.closeDrawer}
          panel = {this.state.panel}
          matrixType={this.state.matrixType}
        />
        {(!this.props.token || this.state.redirect) && <Redirect to="/" />}
        {!this.props.dataset && <Redirect to="/datasets" />}
        {this.state.redirectForm  && <Redirect to="/builder" />}
      </Fragment>
    );
  }
}

ClassifierPanel.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ClassifierPanel);
